<template>
  <div>
    <el-row type="flex" style="padding: 20px 0px">
      <el-col style="text-align: left">
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="pageSizes"
          :total="total"
          :default-sort="defaultSort"
          @current-change="currentChange"
          @size-change="sizeChange"
        ></el-pagination>
      </el-col>
      <slot name="btn"></slot>
    </el-row>

    <el-table
      :data="data.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
      :row-key="rowKey"
      :empty-text="emptyText"
      :summary-method="summaryMethod"
      @row-contextmenu="(row, col) => $emit('row-contextmenu', row, col)"
      @row-dblclick="(row) => $emit('row-dblclick', row)"
      @sort-change="(val) => $emit('sort-change', val)"
      :show-summary="showSummary"
      :border="border"
    >
      <slot></slot>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    pageSizes: Array,
    defaultSort: Object,
    rowKey: String,
    emptyText: String,
    summaryMethod: Function,
    border: Boolean,
    showSummary: Boolean,
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    total() {
      return this.data.length;
    },
  },
  watch: {
    total(newVal) {
      const totalPages = Math.round(newVal / this.pageSize + 1);
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }
    },
  },
  methods: {
    currentChange(val) {
      this.currentPage = val;
    },
    sizeChange(val) {
      this.pageSize = val;
    },
    getRowKeys(row) {
      return row._id;
    },
  },
};
</script>

<style></style>
